module.exports = __webpack_public_path__ + "static/media/zw.8b885465.svg";